module.exports = __webpack_public_path__ + "static/ArtjokerVCRU-a769b8a92b1b0f16463774dd5e3dcb36.png";